import React, { useCallback, useEffect, useState } from 'react';
import { SettingsStyles } from './Settings.styles';
import CheckBox from 'components/CheckBox';
import { handleFollowAutoAcceptApi } from 'redux/features/LoginSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Notification } from 'components/CustomNotification';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from 'components';
import useWindowDimensions from 'components/Dimention';
import { swipeModalWidth } from 'utils/helper';
import { useNavigate } from 'react-router-dom';
import { getProfileByuserId } from 'redux/features/ProfileSlice';

export default function NetworkInformation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;

  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const [fieldValue, setFieldValue] = useState({
    acceptFollowRequest: false,
  });
  const { t } = useTranslation();

  useEffect(() => {
    if (getProfile?.autoFollowRequest) {
      setFieldValue((prevState) => ({
        ...prevState,
        acceptFollowRequest: true,
      }));
    }
  }, [getProfile]);

  const handleFieldValue = useCallback((data, name) => {
    setFieldValue((prevState) => ({
      ...prevState,
      [name]: data,
    }));
    dispatch(handleFollowAutoAcceptApi(data))
      .then((res) => {
        setFieldValue((prevState) => ({
          ...prevState,
          [name]: data,
        }));
        dispatch(getProfileByuserId(getProfile.userId));
        Notification('success', res?.data?.message);
      })
      .catch(() => {
        setFieldValue((prevState) => ({
          ...prevState,
          [name]: data,
        }));
        Notification('warning', 'Something went wrong');
      });
  }, [getProfile]);

  return (
    <SettingsStyles>
      <div className="setting-info-container">
        <div className="setting-title">
          {isSmallScreen && (
            <CloseIcon
              customStyle="back-icon"
              iconType="back"
              onClick={() => navigate('/settings')}
            />
          )}
          {t('Settings.NetworkInformation')}
        </div>
        <div className="accept-request-label">
          <div>
            <div className='setting-help-title'>{t('Settings.Accepting')}</div>
            <div className="accept-request-helper">
              {t('Settings.Enabled')}
            </div>
          </div>
          <CheckBox
            onChange={(data) => handleFieldValue(data, 'acceptFollowRequest')}
            value={fieldValue.acceptFollowRequest}
          />
        </div>
      </div>
    </SettingsStyles>
  );
}
